import type {
	BoundActions,
	HookActionsFunction,
	HookStateFunction,
	Store,
	StoreActionApi,
} from 'react-sweet-state';
import { createStore, createActionsHook, createStateHook, createSelector } from 'react-sweet-state';

export enum LocalActivityAction {
	deleted = 'deleted',
	viewed = 'viewed',
}

export type DehydratedEvent = {
	id: string;
	action: LocalActivityAction;
	timestamp: string;
	content: {
		id?: string | null;
		__typename: 'Content';
	};
	__typename: 'LocalActivityEvent';
};

export const localActivityStore: Store<
	{
		localActivity: DehydratedEvent[];
	},
	{
		setLocalActivity: (localActivity: DehydratedEvent[]) => ({
			setState,
		}: StoreActionApi<{
			localActivity: DehydratedEvent[];
		}>) => void;
		getLocalActivity: () => ({
			getState,
		}: StoreActionApi<{
			localActivity: DehydratedEvent[];
		}>) => DehydratedEvent[];
	}
> = createStore({
	name: 'localActivityStore',
	initialState: {
		localActivity: [] as DehydratedEvent[],
	},
	actions: {
		setLocalActivity:
			(
				localActivity: DehydratedEvent[],
			): (({
				setState,
			}: StoreActionApi<{
				localActivity: DehydratedEvent[];
			}>) => void) =>
			({ setState }) => {
				setState({ localActivity: [...localActivity] });
			},
		getLocalActivity:
			(): (({
				getState,
			}: StoreActionApi<{
				localActivity: DehydratedEvent[];
			}>) => DehydratedEvent[]) =>
			({ getState }) => {
				return getState().localActivity;
			},
	},
});

const localActivitySelector = createSelector(
	(state: any) => state.localActivity,
	(localActivity) => localActivity,
);
export const useLocalActivityCache: HookStateFunction<any, void> = createStateHook(
	localActivityStore,
	{
		selector: localActivitySelector,
	},
);

export const useLocalActivityCacheStoreActions: HookActionsFunction<
	BoundActions<
		{
			localActivity: DehydratedEvent[];
		},
		{
			setLocalActivity: (localActivity: DehydratedEvent[]) => ({
				setState,
			}: StoreActionApi<{
				localActivity: DehydratedEvent[];
			}>) => void;
			getLocalActivity: () => ({
				getState,
			}: StoreActionApi<{
				localActivity: DehydratedEvent[];
			}>) => DehydratedEvent[];
		}
	>
> = createActionsHook(localActivityStore);
